import { footerInfo, navLinks } from '@/mocks/homeData';

const partnerPlaceholders = Array.from({ length: 6 }, (_, i) => i);

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="inline-block mb-4">
              <span className="text-xl font-bold text-background-50 font-heading whitespace-nowrap">吃瓜网51</span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {footerInfo.description}
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" onClick={(e) => handleClick(e, '#contact')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-line text-base"></i>
              </a>
              <a href="#contact" onClick={(e) => handleClick(e, '#contact')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#contact" onClick={(e) => handleClick(e, '#contact')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">热门专题</h4>
            <ul className="space-y-2.5">
              <li><a href="#updates" onClick={(e) => handleClick(e, '#updates')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a></li>
              <li><a href="#ranking" onClick={(e) => handleClick(e, '#ranking')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">吃瓜热度榜</a></li>
              <li><a href="#cards" onClick={(e) => handleClick(e, '#cards')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门爆料</a></li>
              <li><a href="#carousel" onClick={(e) => handleClick(e, '#carousel')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a></li>
              <li><a href="#index" onClick={(e) => handleClick(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h4>
            <div className="grid grid-cols-3 gap-3">
              {partnerPlaceholders.map((i) => (
                <div
                  key={i}
                  className="aspect-[3/2] rounded-lg bg-background-800 flex items-center justify-center"
                >
                  <span className="text-xs text-background-600">合作伙伴</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 吃瓜网51 版权所有 | 吃瓜网51官网版 吃瓜网51网页版 吃瓜网51正式版
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}